// ============================================================
// COVRFLY® — Selector de MagSafe Premium
// Versión: 1.5.3 (Label: "Compatible con MagSafe")
// ============================================================

(function () {
  'use strict';

  const LOG = (...args) => console.log('[COVRFLY-MAGSAFE]', ...args);
  LOG('Iniciando selector de MagSafe v1.5.3...');

  // CLEANUP
  if (window.__covrflyMagsafe && typeof window.__covrflyMagsafe.cleanup === 'function') {
    window.__covrflyMagsafe.cleanup();
  }

  ['#covrfly-magsafe-styles','#covrfly-magsafe-wrap'].forEach(sel => {
    const el = document.querySelector(sel);
    if (el) el.remove();
  });

  // CONFIG
  const SHOULD_HIDE_MAGSAFE = (modelText) => {
    const t = modelText.toLowerCase();
    if (/(samsung|galaxy)\b/.test(t)) return true;
    if (/iphone\s*se\b/.test(t)) return true;
    if (/iphone\s*(?:[6-9]|10|x|xr|xs|11)(?:\s*(?:plus|pro|pro\s*max|max|mini))?\b/.test(t)) return true;
    return false;
  };

  function getPriceDisplay() {
    const currency = window.Shopify?.currency?.active || 'MXN';
    const prices = {'MXN':{amount:'100'},'USD':{amount:'5'},'EUR':{amount:'5'},'CAD':{amount:'7'},'GBP':{amount:'4'}};
    return `+ $${(prices[currency]||prices['MXN']).amount}`;
  }

  function triggerHaptic() { if (navigator.vibrate) navigator.vibrate(10); }

  // ICONS
  const MAGSAFE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 1034.66"><path d="M373.8 15c48.44 0 95.43 9.48 139.66 28.19 42.72 18.07 81.1 43.94 114.05 76.9s58.83 71.33 76.9 114.05c18.71 44.23 28.19 91.21 28.19 139.66s-9.48 95.43-28.19 139.66c-18.07 42.72-43.94 81.1-76.9 114.05s-71.33 58.83-114.05 76.9c-44.23 18.71-91.21 28.19-139.66 28.19s-95.43-9.48-139.66-28.19c-42.72-18.07-81.1-43.94-114.05-76.9s-58.83-71.33-76.9-114.05C24.48 469.23 15 422.25 15 373.8s9.48-95.43 28.19-139.66c18.07-42.72 43.94-81.1 76.9-114.05s71.33-58.83 114.05-76.9C278.37 24.48 325.35 15 373.8 15m0-15C167.36 0 0 167.36 0 373.8s167.36 373.8 373.8 373.8 373.8-167.36 373.8-373.8S580.25 0 373.8 0Z" fill="currentColor"/><path d="M373.8 103.03c36.56 0 72.02 7.16 105.39 21.27 32.24 13.64 61.2 33.16 86.07 58.03 24.87 24.87 44.4 53.83 58.03 86.07 14.12 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-13.64 32.24-33.16 61.2-58.03 86.07-24.87 24.87-53.83 44.4-86.07 58.03-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.16-105.39-21.27c-32.24-13.64-61.2-33.16-86.07-58.03-24.87-24.87-44.4-53.83-58.03-86.07-14.12-33.37-21.27-68.83-21.27-105.39s7.16-72.02 21.27-105.39c13.64-32.24 33.16-61.2 58.03-86.07 24.87-24.87 53.83-44.4 86.07-58.03 33.37-14.12 68.83-21.27 105.39-21.27m0-14.87c-157.75 0-285.64 127.89-285.64 285.64S216.05 659.44 373.8 659.44 659.44 531.55 659.44 373.8 531.56 88.16 373.8 88.16ZM372.79 811.48c20.12 0 36.49 16.37 36.49 36.49v135.2c0 20.12-16.37 36.49-36.49 36.49s-36.49-16.37-36.49-36.49v-135.2c0-20.12 16.37-36.49 36.49-36.49m0-15c-28.44 0-51.49 23.05-51.49 51.49v135.2c0 28.44 23.05 51.49 51.49 51.49s51.49-23.05 51.49-51.49v-135.2c0-28.44-23.05-51.49-51.49-51.49Z" fill="currentColor"/><path d="M335.92 553.7c-2.02 0-4.01-.33-5.92-.97-8.98-3.04-11.28-10.45-11.63-16.14-.15-2.26.05-4.63.6-7.24l23.93-115.17s.01-.07.01-.1c0-.28-.22-.5-.5-.5l-68.58 1.05c-8.42 0-15.85-5.15-18.5-12.83-1.37-3.98-1.35-7.82.05-11.4.49-1.26 1.22-2.53 2.24-3.89l138.09-184.27c3.75-5 9.63-7.99 15.73-7.99 2.02 0 4.01.33 5.92.97 8.98 3.04 11.28 10.45 11.63 16.14.15 2.26-.05 4.62-.6 7.24l-23.93 115.18c-.05.25.1.5.34.58.05.02.1.02.15.02l68.58-1.05c8.41 0 15.85 5.15 18.5 12.83 1.37 3.98 1.35 7.82-.05 11.41-.48 1.24-1.22 2.51-2.24 3.88l-37.66 50.26-100.43 134.01c-3.75 5-9.63 7.99-15.73 7.99Z" fill="currentColor"/></svg>`;
  
  const NO_MAGSAFE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 747.61"><path d="M15 373.8c0-48.44 9.48-95.43 28.19-139.65 16.19-38.29 38.64-73.07 66.85-103.6l-10.61-10.61C37.72 186.61 0 275.8 0 373.8s37.72 187.21 99.43 253.87l10.61-10.61c-28.21-30.53-50.66-65.31-66.85-103.6C24.48 469.24 15 422.25 15 373.8Zm633.17-253.86-10.61 10.61c28.21 30.53 50.66 65.31 66.85 103.6 18.71 44.22 28.19 91.21 28.19 139.65s-9.48 95.44-28.19 139.66c-16.19 38.29-38.64 73.07-66.85 103.6l10.6 10.6C709.88 561 747.6 471.8 747.6 373.8s-37.72-187.19-99.43-253.86ZM513.46 704.42c-44.23 18.7-91.22 28.19-139.66 28.19s-95.43-9.49-139.66-28.19c-38.28-16.2-73.07-38.65-103.59-66.86l-10.61 10.61c66.67 61.72 155.85 99.44 253.86 99.44s187.2-37.72 253.86-99.44l-10.61-10.6c-30.53 28.2-65.31 50.65-103.59 66.85ZM373.8 0c-98.01 0-187.2 37.72-253.87 99.43l10.62 10.62c30.52-28.21 65.31-50.67 103.59-66.86C278.37 24.49 325.35 15 373.8 15s95.43 9.49 139.66 28.19c38.28 16.19 73.06 38.65 103.59 66.85l10.61-10.61C561 37.72 471.81 0 373.8 0Z" fill="currentColor"/><path d="M103.03 373.8c0-36.56 7.16-72.02 21.27-105.39 11.76-27.79 27.88-53.14 48.06-75.54l-10.53-10.53C116.04 233 88.16 300.14 88.16 373.8s27.88 140.81 73.67 191.47l10.52-10.53c-20.16-22.4-36.29-47.75-48.05-75.55-14.11-33.37-21.27-68.83-21.27-105.39Zm451.71 201.45c-22.4 20.16-47.76 36.29-75.55 48.05-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.15-105.39-21.27c-27.79-11.76-53.15-27.89-75.55-48.05l-10.52 10.52c50.65 45.79 117.8 73.67 191.46 73.67s140.8-27.88 191.46-73.66l-10.52-10.53Zm31.03-392.92-10.53 10.54c20.17 22.4 36.3 47.75 48.06 75.54 14.11 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-11.76 27.8-27.89 53.15-48.06 75.55l10.53 10.53c45.79-50.66 73.67-117.81 73.67-191.47s-27.88-140.81-73.67-191.47ZM373.8 88.16c-73.66 0-140.81 27.88-191.47 73.67l10.53 10.53c22.4-20.17 47.76-36.3 75.55-48.05 33.37-14.12 68.83-21.28 105.39-21.28s72.02 7.16 105.39 21.28c27.79 11.75 53.15 27.88 75.55 48.04l10.53-10.52c-50.66-45.79-117.81-73.67-191.47-73.67Z" fill="currentColor"/><path d="M384.41 373.8 697 61.21a7.502 7.502 0 1 0-10.61-10.61L373.8 363.19 61.21 50.6A7.502 7.502 0 1 0 50.6 61.21L363.19 373.8 50.6 686.4a7.502 7.502 0 0 0 0 10.61c1.46 1.46 3.38 2.2 5.3 2.2s3.84-.73 5.3-2.2l312.59-312.59 312.59 312.59c1.46 1.46 3.38 2.2 5.3 2.2s3.84-.73 5.3-2.2a7.502 7.502 0 0 0 0-10.61L384.39 373.81Z" fill="currentColor"/></svg>`;

  // DOM
  function findVisibleVariantSelects() {
    const all = document.querySelectorAll('variant-selects');
    if (!all.length) return null;
    if (all.length === 1) return all[0];
    for (const vs of all) if (vs.offsetParent !== null) return vs;
    return all[0];
  }

  const variantSelects = findVisibleVariantSelects();
  if (!variantSelects) { LOG('ERROR: No variant-selects'); return; }

  const magsafeSelect = variantSelects.querySelector('select[name="options[MagSafe]"]') || document.querySelector('select[name="options[MagSafe]"]');
  if (!magsafeSelect) { LOG('ERROR: No MagSafe select'); return; }

  const magsafeContainer = magsafeSelect.closest('.product-form__input');
  const modelSelect = variantSelects.querySelector('select[name="options[Elige tu Modelo]"]')
    || variantSelects.querySelector('select[name="options[Modelo]"]')
    || document.querySelector('select[name="options[Elige tu Modelo]"]')
    || document.querySelector('select[name="options[Modelo]"]');

  // Hide native
  function hideNativeMagsafeSelect() {
    let c = 0;
    if (magsafeContainer) { magsafeContainer.style.cssText = 'display:none!important;visibility:hidden;position:absolute;pointer-events:none'; c++; }
    document.querySelectorAll('select[name="options[MagSafe]"]').forEach(sel => {
      const ct = sel.closest('.product-form__input');
      if (ct && !ct.closest('#covrfly-magsafe-wrap')) { ct.style.cssText = 'display:none!important;visibility:hidden;position:absolute;pointer-events:none'; c++; }
    });
    if (c) LOG('Nativo ocultado:', c);
  }
  hideNativeMagsafeSelect();

  // STYLES
  const styles = document.createElement('style');
  styles.id = 'covrfly-magsafe-styles';
  styles.textContent = `
    .cf-native-magsafe-hidden,.product-form__input:has(select[name="options[MagSafe]"]):not(#covrfly-magsafe-wrap *){display:none!important}
    #covrfly-magsafe-wrap{margin-bottom:20px}
    #covrfly-magsafe-wrap.cf-hidden{display:none!important}
    .cf-magsafe-header{font-size:14px;font-weight:600;color:#000;margin-bottom:10px}
    .cf-magsafe-cards{display:flex;flex-direction:column;gap:10px}
    .cf-magsafe-card{position:relative;display:flex;align-items:center;gap:14px;padding:16px 18px;border-radius:16px;cursor:pointer;overflow:hidden;transition:all .3s cubic-bezier(.25,.8,.25,1)}
    .cf-magsafe-card.magsafe.is-selected{background:linear-gradient(135deg,#fff 0%,#f0f0f0 100%);border:2px solid #000;box-shadow:0 8px 24px rgba(0,0,0,.12);padding:15px 17px}
    .cf-magsafe-card.magsafe.is-selected::after{content:'';position:absolute;top:0;left:-100%;width:60%;height:100%;background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,.4) 40%,rgba(255,255,255,.8) 50%,rgba(255,255,255,.4) 60%,transparent 100%);transform:skewX(-20deg);animation:cf-sheen 4s ease-in-out infinite;pointer-events:none}
    @keyframes cf-sheen{0%{left:-100%;opacity:0}5%{opacity:1}15%{left:150%;opacity:1}20%{opacity:0}100%{left:150%;opacity:0}}
    .cf-magsafe-card.magsafe:not(.is-selected){background:#fff;border:1.5px solid #e5e5e5;opacity:.88;transform:scale(.99)}
    .cf-magsafe-card.magsafe:not(.is-selected)::after{display:none}
    .cf-magsafe-card.magsafe:not(.is-selected):hover{opacity:.95;border-color:#d4d4d4}
    .cf-magsafe-card.standard{background:#fff;border:1.5px solid #e5e5e5;opacity:.88;transform:scale(.99)}
    .cf-magsafe-card.standard:hover{opacity:.95;border-color:#d4d4d4}
    .cf-magsafe-card.standard.is-selected{border:2px solid #000;opacity:1;transform:scale(1);background:#f5f5f5;padding:15px 17px}
    .cf-magsafe-icon{width:40px;height:40px;min-width:40px;color:#000;display:flex;align-items:center;justify-content:center;transition:color .2s}
    .cf-magsafe-icon svg{width:100%;height:100%}
    .cf-magsafe-card:not(.is-selected) .cf-magsafe-icon{color:#a3a3a3}
    .cf-magsafe-content{flex:1}
    .cf-magsafe-label{font-size:15px;font-weight:600;color:#000;line-height:1.3}
    .cf-magsafe-sublabel{font-size:12px;color:#525252;margin-top:2px}
    .cf-magsafe-card:not(.is-selected) .cf-magsafe-label{color:#737373}
    .cf-magsafe-card:not(.is-selected) .cf-magsafe-sublabel{color:#a3a3a3}
    .cf-magsafe-badge{background:#f5f5f5;color:#555;font-size:13px;font-weight:400;padding:6px 12px;border-radius:99px;border:1px solid #e5e5e5;white-space:nowrap}
    .cf-magsafe-card:not(.is-selected) .cf-magsafe-badge{color:#999;border-color:#e5e5e5}
    @media(max-width:400px){.cf-magsafe-card{padding:14px;gap:12px}.cf-magsafe-icon{width:36px;height:36px;min-width:36px}.cf-magsafe-label{font-size:14px}.cf-magsafe-badge{font-size:12px;padding:8px 12px}}
    @media(prefers-reduced-motion:reduce){.cf-magsafe-card.magsafe.is-selected::after{animation:none;display:none}}
  `;
  document.head.appendChild(styles);

  // STATE
  let selectedValue = magsafeSelect.value || 'Si';
  const priceDisplay = getPriceDisplay();

  // HTML — "Compatible con MagSafe"
  const wrap = document.createElement('div');
  wrap.id = 'covrfly-magsafe-wrap';
  wrap.innerHTML = `
    <div class="cf-magsafe-header">Compatible con MagSafe</div>
    <div class="cf-magsafe-cards">
      <div class="cf-magsafe-card magsafe ${selectedValue==='Si'?'is-selected':''}" data-value="Si" role="radio" aria-checked="${selectedValue==='Si'}" tabindex="0">
        <div class="cf-magsafe-icon">${MAGSAFE_ICON}</div>
        <div class="cf-magsafe-content">
          <div class="cf-magsafe-label">Edición MagSafe</div>
          <div class="cf-magsafe-sublabel">Agarre magnético para soporte y carga</div>
        </div>
        <div class="cf-magsafe-badge" style="${selectedValue==='Si'?'display:none':''}">${priceDisplay}</div>
      </div>
      <div class="cf-magsafe-card standard ${selectedValue==='No'?'is-selected':''}" data-value="No" role="radio" aria-checked="${selectedValue==='No'}" tabindex="0">
        <div class="cf-magsafe-icon">${NO_MAGSAFE_ICON}</div>
        <div class="cf-magsafe-content">
          <div class="cf-magsafe-label">Edición Estándar</div>
        </div>
      </div>
    </div>
  `;

  // Insert
  const modelTrigger = document.querySelector('#covrfly-trigger-wrap');
  if (modelTrigger) modelTrigger.insertAdjacentElement('afterend', wrap);
  else if (magsafeContainer) magsafeContainer.insertAdjacentElement('beforebegin', wrap);
  else variantSelects.insertAdjacentElement('beforebegin', wrap);

  // REFS
  const cards = wrap.querySelectorAll('.cf-magsafe-card');

  // FUNCTIONS
  function selectOption(value, isUser = false) {
    selectedValue = value;
    cards.forEach(card => {
      const sel = card.dataset.value === value;
      card.classList.toggle('is-selected', sel);
      card.setAttribute('aria-checked', sel);
    });
    const badge = wrap.querySelector('.cf-magsafe-badge');
    if (badge) badge.style.display = value === 'Si' ? 'none' : '';
    if (isUser && value === 'Si') triggerHaptic();
    magsafeSelect.value = value;
    magsafeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    LOG('Seleccionado:', value);
  }

  function checkVisibility() {
    const model = modelSelect ? modelSelect.value : '';
    const hide = SHOULD_HIDE_MAGSAFE(model);
    wrap.classList.toggle('cf-hidden', hide);
    hideNativeMagsafeSelect();
    LOG('Visibilidad:', hide ? 'OCULTO' : 'VISIBLE', '←', model);
  }

  // EVENTS
  cards.forEach(card => {
    card.addEventListener('click', () => selectOption(card.dataset.value, true));
    card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(card.dataset.value, true); } });
  });

  if (modelSelect) modelSelect.addEventListener('change', () => {
    // COVRFLY UX: Al cambiar modelo, restablecer a MagSafe "Si"
    const model = modelSelect.value || '';
    const shouldHide = SHOULD_HIDE_MAGSAFE(model);
    
    // Solo restablecer a MagSafe si el modelo es compatible (no Samsung, no iPhone 11 o menor)
    if (!shouldHide && selectedValue !== 'Si') {
      selectOption('Si', false);
      LOG('✨ MagSafe restablecido a "Si" por cambio de modelo');
    }
    
    checkVisibility();
  });

  magsafeSelect.addEventListener('change', () => {
    const v = magsafeSelect.value;
    if (v && v !== selectedValue) {
      selectedValue = v;
      cards.forEach(card => {
        const sel = card.dataset.value === v;
        card.classList.toggle('is-selected', sel);
        card.setAttribute('aria-checked', sel);
      });
    }
  });

  // Observer
  const form = document.querySelector('form[action*="/cart/add"]') || variantSelects;
  if (form) new MutationObserver(() => hideNativeMagsafeSelect()).observe(form, { childList: true, subtree: true });

  setTimeout(hideNativeMagsafeSelect, 500);
  setTimeout(hideNativeMagsafeSelect, 1000);

  // CLEANUP
  window.__covrflyMagsafe = {
    cleanup: () => { ['#covrfly-magsafe-styles','#covrfly-magsafe-wrap'].forEach(s => { const e = document.querySelector(s); if (e) e.remove(); }); },
    version: '1.5.3',
    getState: () => ({ selectedValue, isVisible: !wrap.classList.contains('cf-hidden'), currency: window.Shopify?.currency?.active || 'MXN' })
  };

  // INIT
  if (magsafeSelect.value !== 'Si') selectOption('Si', false);
  checkVisibility();

  LOG('✅ v1.5.3 inicializado — Label: "Compatible con MagSafe"');

  // Anti-FOUC v2.0: señal al orquestador
  window.cfPdpDone && window.cfPdpDone('magsafe');
  LOG('📡 Anti-FOUC v2.0: magsafe done');

})();
